import React, { useState, useEffect } from 'react';
import "./shop.css";
// svgs
import Reserve from '../../assets/icons/shop/reserve.svg'
// import Phone from '../../assets/icons/shop/phone.svg'
import Snapp from '../../assets/icons/shop/snapfood.svg'
import Site from '../../assets/icons/shop/site.svg'
import Whatsapp from '../../assets/icons/footer/whatsapp.svg'
import Youtub from '../../assets/icons/footer/youtub.svg'
import { getShopBySearch, imgBaseUrl2, getBranch } from '../../utils/api'
import ContactUsComponent from '../contact-us-component/contact-us'
import { Col, Form } from 'react-bootstrap';
import SecondaryBanner from '../banner/secondary-banner';
import LogoWhite from '../../assets/images/logo-shadow.svg';
import { Modal, Button } from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';
import CloseCollapse from '../../assets/icons/close.svg';
import Loader from '../loader/dotloader'
import { useLocation, useNavigate } from 'react-router-dom';
import Phone from '../../assets/icons/phone-white.svg'
import Check from '../../assets/icons/check.svg'
const ContactUs = () => {
  const [contactInfo, setContactInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [branch, setBranch] = useState([]);
  const [visible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Fetch categories
  useEffect(() => {
    const fetchContact = async () => {
      try {
        setLoading(true)
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getShopBySearch(pay);
        if (res.data.isSuccess) {
          const items = res.data.data.items;
          setContactInfo(items.filter((product) => product.isActive == true));
          setLoading(false)
        }
      } catch (error) {
        setLoading(false)
        console.error('Error fetching Contact:', error);
      }
    };
    fetchContact();
  }, []);

  // Helper function to find a contact by title
  const getContactValue = (title) => {
    const contact = contactInfo.find((item) => item.title === title);
    return contact ? contact.link : '';
  };
  const phoneNumber = getContactValue('تماس تلفنی');
  const getContactImage = (title) => {
    const contact = contactInfo.find((item) => item.title === title);
    return contact ? contact.logoPath : '';
  };
  const handleCloseDialog = () => {
    setVisible(false);

    const params = new URLSearchParams(location.search);
    params.delete('visible');

    navigate(
      {
        pathname: location.pathname,
        search: params.toString()
          ? `?${params.toString()}`
          : ''
      },
      { replace: true }
    );
  };

  const fetchBranch = async (newPage = 0) => {
    try {
      setLoading(true);
      const pay = {
        pageIndex: 0,
        pageSize: 2000,
      };
      const res = await getBranch(pay);
      if (res.data.isSuccess) {
        // مرتب‌سازی بر اساس code
        const sortedBranches = res.data.data.items.sort((a, b) => a.code - b.code);

        setBranch(sortedBranches);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching branch:', error);
    }
  };
  useEffect(() => {

    fetchBranch();
  }, []);
  return (
    <div>
      {loading && <Loader isLoading={loading} />}

      <div>
        <SecondaryBanner slug='shops1' />
      </div>
      <div className='container' style={{ marginTop: '7em' }}>

        <h1 className='text-3xl section-title font-bold leading-10' style={{ borderBottom: '2px solid #00A14B', width: '240px' }}>راه‌های ثبت سفارش</h1>

        <h6 className='text-xl	font-medium	 mt-5'>شما می‌توانید از طریق راه‌های زیر سفارشتان را ثبت کنید.</h6>
        <div className='row mt-5 gy-5 shop-list mx-auto justify-content-center'>
          {contactInfo.map(item => (
            <div className='col-md-6 col-lg-3 col-12' key={item.id}>
              {item.title === 'تماس تلفنی' ? (
                <div
                  className='item cursor-pointer'
                  onClick={(e) => setVisible(true)}
                >
                  <div className='icon-shop'>
                    <div className='bg-icon'>
                      <img src={imgBaseUrl2 + 'io/' + item.logoPath} />
                    </div>
                  </div>
                  <h6 className='text-center'>{item.title}</h6>
                </div>
              ) : (
                <a href={item.link} target='_blank' className='item'>
                  <div className='icon-shop'>
                    <div className='bg-icon'>
                      <img src={imgBaseUrl2 + 'io/' + item.logoPath} />
                    </div>
                  </div>
                  <h6 className='text-center'>{item.title}</h6>
                </a>
              )}
            </div>
          ))}



        </div>

        <Dialog
          visible={visible}
          style={{ width: '50vw' }}
          breakpoints={{
            '1800px': '60vw',
            '1100px': '80vw',
            '600px': '95vw'
          }}
          contentStyle={{ minHeight: '70vh' }}
          onHide={handleCloseDialog}
          className="custom-dialog"
        >
          <div className="px-3 ">
            <h4 className="text-center mb-4 font-bold">
              تماس تلفنی

            </h4>
            <h6 className='!text-[#333333] '>برای تماس با مجموعه <a href={phoneNumber} className='!text-[#00A14B] font-bold'>اینجا</a> کلیک کنید و در صورت تماس با شعب، شعبه مورد نظر را انتخاب کنید. </h6>
            <div className="branch-list row relative">
              {branch.map((item, index) => (

                <div className='col-12 col-md-4 ' key={item.id || index} onClick={() => setSelectedBranch(item)}>
                   
                  <div

                    className={`d-flex align-items-center justify-content-between border-bottom py-2 cursor-pointer ${selectedBranch?.id === item.id ? 'bg-[#00a14b17]' : ''
                      }`}

                  > <div className='d-flex align-items-center'>
                    {selectedBranch?.id === item.id && <><img src={Check} alt="" /></>}  
                       <span>{item.title || 'عنوان شعبه'}</span>
                    </div>
               
                    <span className="text-[#00a14b] font-bold">{item.code}</span>
                  </div>
                </div>
              ))}

              <div className='d-flex align-items-center justify-content-end mt-4 phone-btn ' >
              
                <a className='d-flex align-items-center justify-content-center' href={
                  selectedBranch
                    ? `${phoneNumber};${selectedBranch.code}`
                    : '#'
                }>
                  <button
                    className='btn btn-primary '
                    disabled={!selectedBranch}

                  >

                    <img src={Phone} alt="" /> <span className='web-btn-text'>تماس با شعب</span>
                  </button></a>

              </div>
            </div>






            <div className='dailog-max-btn-right'></div>
            <div className='dailog-max-btn-left'></div>
            <div className='bg-modal'>
              <div className="dailog-max-btn">

                <button className="btn" onClick={handleCloseDialog}>
                  <img src={CloseCollapse} alt="Collapse" />
                </button>
              </div>
            </div>

          </div>
        </Dialog>
      </div>

    </div>
  );
}

export default ContactUs;
